module.exports = __webpack_public_path__ + "img/ic_weirenzheng.c626183e.svg";